export default __webpack_public_path__ + "static/media/577a464911332616a2929c4036fe7032.0813879d.png";